import React from 'react'
import WaitingForLogin from '../../../modules/Login/WatingForLogin'

const WaitingForLoginPage = () => {
    return <WaitingForLogin />
}

export default WaitingForLoginPage